import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["toggle", "close", "modal"];

  get headerBookingToggle() {
    return document.querySelector('.resort-booking-sidebar__toggle');
  }

  get footerBookingToggle() {
    return document.querySelector('.footer-bar .resort-booking-sidebar__toggle');
  }

  get closeToggle() {
    return document.querySelector('.resort-booking-sidebar__close');
  }

  initialize() {
    this.state = {
      active: false,
      trigger: null,
      mouseDown: false,
    };
  }

  connect() {
    this.handleFocusOut = this.onFocusOut.bind(this);
    this.handleMouseDown = this.onMouseDown.bind(this);
    this.handleMouseUp = this.onMouseUp.bind(this);

    document.addEventListener('click', this.checkOutsideClick.bind(this));
    this.headerBookingToggle.addEventListener('click', this.toggleActive.bind(this));
    this.footerBookingToggle.addEventListener('click', this.toggleActive.bind(this));
    this.element.addEventListener('keyup', this.handleKeyUp.bind(this));

    this.element.addEventListener('focusout', this.handleFocusOut);
    document.addEventListener('mousedown', this.handleMouseDown);
    document.addEventListener('mouseup', this.handleMouseUp);

    this.modal = this.element
    this.modalToggle = this.headerBookingToggle
    this.footerModalToggle = this.footerBookingToggle
  }

  onMouseDown() {
    this.state.mouseDown = true;
  }

  onMouseUp() {
    this.state.mouseDown = false;
  }

  disconnect() {
    document.removeEventListener('click', this.checkOutsideClick.bind(this));
    this.headerBookingToggle.removeEventListener('click', this.toggleActive.bind(this));
    this.footerBookingToggle.removeEventListener('click', this.toggleActive.bind(this));
    this.element.removeEventListener('keyup', this.handleKeyUp.bind(this));

    this.element.removeEventListener('focusout', this.handleFocusOut);
    document.removeEventListener('mousedown', this.handleMouseDown);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  onFocusOut(event) {
    if (this.state.mouseDown) return;

    const newFocus = event.relatedTarget;

    if (this.element.contains(newFocus)) return;

    this.clearActive();
  }

  toggleActive(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.state.active) {
      this.clearActive();
      return;
    }

    this.state.trigger = event.target;
    this.setActive();
  }

  setActive() {
    this.state.active = true;
    this.element.classList.add('is-active');
    this.element.setAttribute('aria-hidden', 'false');
    this.headerBookingToggle.setAttribute('aria-expanded', 'true');
  }

  clearActive(shouldFocusTrigger = true) {
    this.state.active = false;
    this.element.classList.remove('is-active');
    this.element.setAttribute('aria-hidden', 'true');
    this.headerBookingToggle.setAttribute('aria-expanded', 'false');

    if (!shouldFocusTrigger) return;
    this.state.trigger.focus();
    this.state.trigger = null;
  }

  checkOutsideClick(event) {
    if (!this.state.active) return;
    const module = this.element;
    const target = event.target;
    const isWithinModule = module.contains(target);
    if (!isWithinModule) this.clearActive(false);
  }

  handleKeyUp(event) {
    if ((event.keyCode == 27) && this.state.active) {
      this.clearActive();
    }
  }
}

